import React from 'react';

// Logo oficial de Exygen Labs (estructura del dipéptido + wordmark + subtítulo).
// En dark theme se invierte a blanco monocromo. `nameOnly` usa el recorte con
// SOLO "EXYGEN LABS" (sin molécula ni "RESEARCH PEPTIDES") — es exclusivo de
// la barra superior por orden de Christian (2026-07-20); no usarlo en otro lado.
const LOGO_SRC = process.env.PUBLIC_URL + '/images/exygen-logo.png';
const LOGO_NAME_SRC = process.env.PUBLIC_URL + '/images/exygen-logo-wordmark.png';
// "EXYGEN LABS" + "RESEARCH PEPTIDES", sin la molécula.
const LOGO_TEXT_SRC = process.env.PUBLIC_URL + '/images/exygen-logo-name.png';

// `noMolecule` deja el nombre y el subtítulo, sin la estructura del dipéptido.
// Lo usa el aviso RUO de la primera visita (orden de Christian, 2026-07-20).
export const BrandMark = ({ className = 'h-8', noMolecule = false }) => (
  <img
    src={noMolecule ? LOGO_TEXT_SRC : LOGO_SRC}
    alt="Exygen Labs"
    className={`${className} w-auto object-contain dark:brightness-0 dark:invert`}
  />
);

// La molécula REAL del logo (el dipéptido completo, recortado del PNG
// oficial), tal cual, SIN caja (orden de Christian, 2026-07-21). En dark se
// invierte a blanco monocromo, igual que el resto de la marca.
const MOLECULE_SRC = process.env.PUBLIC_URL + '/images/exygen-molecule.png';

export const MoleculeMark = ({ className = 'h-12' }) => (
  <img src={MOLECULE_SRC} alt="Exygen Labs"
    className={`${className} w-auto object-contain dark:brightness-0 dark:invert`} />
);

const BrandLogo = ({ compact = false, nameOnly = false }) => (
  <img
    src={nameOnly ? LOGO_NAME_SRC : LOGO_SRC}
    alt="Exygen Labs — Research Peptides"
    data-testid="brand-logo"
    className={`w-auto object-contain dark:brightness-0 dark:invert ${
      // En telefono el ancho del wordmark empujaba la barra y cortaba el boton
      // "Comenzar" y la cuenta. Se acota el ANCHO, no solo el alto.
      compact ? (nameOnly ? 'h-3 max-w-[104px] sm:h-4 sm:max-w-none' : 'h-8 sm:h-9') : 'h-10'}`}
  />
);

export default BrandLogo;
